type ErrorType = {
  error_id: string;
  errors: [
    {
      message: string;
      code: string;
      metadata?: { field?: string };
    }
  ];
};

class ServerError extends Error {
  id: string;
  code: string;
  status: number;
  metadata?: { field?: string };
  url: string;
  constructor(
    { error_id: id, errors: [{ message, code, metadata }] }: ErrorType,
    status: number,
    url: string
  ) {
    super(message);
    this.id = id;
    this.message = message;
    this.code = code;
    this.status = status;
    this.metadata = metadata;
    this.url = url;
  }
}

export { ServerError };
